import * as yup from "yup";
import { validationNotEmpty, validationStringSelect, } from "./defaultValidations";

export default yup.object({
  compName: validationNotEmpty("DIGSIG Company Name/ID"),
  dddField: validationStringSelect("DDD Field"),
  entryName: validationNotEmpty("Entry Name"),
});
